import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 252px - 71px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
